import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { logout } from "../utils/api/authAPI";
import { Power, UserCircle, X } from "lucide-react";
import DoughnutChart from "../components/child/DoughtnutChart";
import { clearUser } from "../store/app/userSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getOrganisationDataWithId } from "../utils/api/organisationAPI";
import { Wallet } from "lucide-react";
import Marquee from "react-fast-marquee";


const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const user = useSelector((state) => state.user);
  const orgIsSubscribed = useSelector((state) => state?.orgData?.orgData?.organization?.isSubscribed);
  const wallet = useSelector((state) => state?.walletData?.walletData);
  //console.log("Wallet Data:", (wallet.creditsRemaining / 60).toFixed(2));

  const dispatch = useDispatch();
  // here user data is dummy
  const location = useLocation(); // Hook to get the current route
  const authData = JSON.parse(localStorage.getItem("auth"));
  const displayName = authData?.user?.displayName || "User";
  const [showBanner, setShowBanner] = useState(() => {
    return localStorage.getItem("nehaVoiceBannerDismissed") !== "true";
  });

  // Handler to close banner and save to localStorage
  const handleCloseBanner = () => {
    setShowBanner(false);
    localStorage.setItem("nehaVoiceBannerDismissed", "true");
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const creditRaw = wallet?.creditsRemaining;
  const creditInMinutes = creditRaw ? creditRaw / 60 : NaN;

  let bgColor = '#e6f9f0'; // default (green)
  let textColor = '#15803d';
  let displayText = 'Loading...';

  if (!isNaN(creditInMinutes)) {
    displayText = `Credit Remaining: ${creditInMinutes.toFixed(2)}`;

    if (creditInMinutes < 0) {
      bgColor = '#ffe6e6'; // strong red
      textColor = '#b91c1c';
    } else if (creditInMinutes < 3) {
      bgColor = '#ffeaea'; // red alert
      textColor = '#dc2626';
    } else if (creditInMinutes < 5) {
      bgColor = '#fff4e5'; // orange
      textColor = '#f97316';
    } else if (creditInMinutes < 7) {
      bgColor = '#fffbe6'; // yellow
      textColor = '#d97706';
    } else {
      bgColor = '#e6f9f0'; // green
      textColor = '#15803d';
    }
  }

  return (
    <>
    
    {/* ===== TOP BANNER ===== */}
    {showBanner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: "40px",
            zIndex: 9999,
            backgroundColor: "#fff3cd",
            borderBottom: "1px solid #ffc107",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1, overflow: "hidden" }}>
            <Marquee speed={50} gradient={false}>
              <span
                style={{
                  paddingRight: "50px",
                  color: "#856404",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Priya Voice is deprecating soon please switch to other voice
              </span>
            </Marquee>
          </div>

          <button
            onClick={handleCloseBanner}
            style={{
              background: "transparent",
              border: "none",
              padding: "8px 12px",
              cursor: "pointer",
            }}
          >
            <X size={18} />
          </button>
        </div>
      )}
    <section className={mobileMenu ? "overlay active" : "overlay "}>

      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
        // height is used to push the content down when the banner is shown remove this style when banner is removed
        style={{
          top: showBanner ? "40px" : "0",
          height: showBanner ? "calc(100vh - 40px)" : "100vh",
          
        }}
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src='/assets/images/logo.png'
              alt='site logo'
              className='light-logo h-100 w-80'
              style={{
                paddingLeft: 15
              }}
            />
            <img
              src='/assets/images/logo-light.png'
              alt='site logo'
              className='dark-logo h-100 w-80'
              style={{
                paddingLeft: 15
              }}
            />
            <img
              src='/assets/images/logo-icon.png'
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>



          <ul className='sidebar-menu' id='sidebar-menu' >
            {/* <li className='sidebar-menu-group-title'>Dashboard</li> */}
            {/* Dashboard dropdown */}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon="mdi:view-dashboard-outline" className="menu-icon" />

                <span>Dashboard</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/'
                    className={(navData) => (navData.isActive ? 'active-page' : '')}
                  >
                    <Icon icon="mdi:home" className="text-primary-main w-5 h-5 mr-2" />
                    Home
                  </NavLink>
                </li>
                {/* <li>
                <NavLink
                  to="/converations"
                  className={(navData) => (navData.isActive ? 'active-page sidebar-submenu-link' : 'sidebar-submenu-link')}
                  onClick={() => window.location.href = "/converations"} // 👈 forces full reload
                >
                  <Icon icon="material-symbols:add-comment" className="text-primary-main w-5 h-5 mr-2" />
                  <span>Conversations</span>
                </NavLink>
                </li> */}

                {/* <li>

                   <NavLink
                  to="/generate-widget"
                  className={(navData) => (navData.isActive ? 'active-page sidebar-submenu-link' : 'sidebar-submenu-link')}
                  onClick={() => window.location.href = "/generate-widget"} // 👈 forces full reload
                >
                  <Icon icon="material-symbols:widgets-outline" className="text-primary-main w-5 h-5 mr-2" />
                  <span>Web Widget</span>
                </NavLink>
              
                </li> */}


              </ul>

            </li>
            {/* Assistant Dropdown */}
            <li className='dropdown' >
              <Link to='#'>
                <>

                  <Icon icon='mdi:hammer-wrench' className='menu-icon' />
                </>

                <span>Build</span>
              </Link>

              <ul className='sidebar-submenu'>
                <li >
                  <NavLink
                    to='/assistant'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:puzzle" className="text-warning-main w-5 h-5 mr-2" />
                    Assistant
                  </NavLink>
                </li>
                {/* Knowledge base */}
                <li >
                  <NavLink
                    to='/knowledge-base'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:book-open-page-variant" className=" w-5 h-5 mr-2" />
                    Knowledge Base
                  </NavLink>
                </li>
                {/* API Key start */}
                <li>
                  <NavLink
                    to='/api-keys'
                    className={(navData) => (navData.isActive ? 'active-page' : '')}
                  >
                    <Icon icon='ant-design:link-outlined' className="text-primary-main w-5 h-5 mr-2" />
                    API Keys
                  </NavLink>
                </li>
                {/* API Key end */}
                <li >
                  <NavLink
                    to='/phone-number'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:phone-outline" className="text-primary-main w-5 h-5 mr-2" />

                    Phone number
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/campaigns'
                    className={(navData) => (navData.isActive ? 'active-page' : '')}
                  >
                   <Icon icon="mdi:history" className="text-primary-main w-5 h-5 mr-2" />

                    Campaign
                  </NavLink>
                </li>
                {/* <li>

                  <NavLink
                    to="/converations"
                    className={(navData) => (navData.isActive ? 'active-page sidebar-submenu-link' : 'sidebar-submenu-link')}
                    onClick={() => window.location.href = "/converations"} // 👈 forces full reload
                  >
                    <Icon icon="material-symbols:add-comment" className="text-primary-main w-5 h-5 mr-2" />
                    <span>Conversations</span>
                  </NavLink>
                </li> */}

                <li>

                  <NavLink
                    to="/generate-widget"
                    className={(navData) => (navData.isActive ? 'active-page sidebar-submenu-link' : 'sidebar-submenu-link')}
                    onClick={() => window.location.href = "/generate-widget"}
                  >
                    <Icon icon="material-symbols:widgets-outline" className="text-primary-main w-5 h-5 mr-2" />
                    <span>Web Widget</span>
                  </NavLink>

                </li>

              </ul>
            </li>
            {/* Call dropdown*/}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon='mdi:phone' className='menu-icon' />
                <span>Calls</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/call-logs'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:history" className="text-primary-600 w-5 h-5 mr-2" />Call Logs
                  </NavLink>
                </li>



              </ul>
            </li>
            {/* Call dropdown*/}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon='mdi:message-text-outline' className='menu-icon' />
                <span>Chats</span>
              </Link>
              <ul className='sidebar-submenu'>

                <li>
                  <NavLink
                    to='/chat-logs'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:message-text" className="text-primary-600 w-5 h-5 mr-2" />
                    Chat Logs
                  </NavLink>
                </li>


              </ul>
            </li>
            {/* Organisation Dropdown */}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon='mdi:office-building' className='menu-icon' />
                <span>Organisations</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/all-organisations'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:office-building" className="text-primary-600 w-5 h-5 mr-2" />Organisation Details
                  </NavLink>
                </li>

              </ul>
            </li>

            {/* Integration Dropdown */}

            {/* User Dropdown */}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon='flowbite:users-group-outline' className='menu-icon' />
                <span>Users</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/all-users'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:office-building" className="text-primary-600 w-5 h-5 mr-2" />Users
                  </NavLink>
                </li>
                <li >
                  <NavLink
                    to='/add-user'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:plus-circle" className="text-warning-main w-5 h-5 mr-2" />Add Users
                  </NavLink>
                </li>
              </ul>
            </li>
            {/* Whatsapp Dropdown */}
            <li className='dropdown' >
              <Link to='#'>
                <Icon icon='mdi:whatsapp' className='menu-icon' />
                <span>Whatsapp </span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/whatsapp-settings'
                    className={(navData) =>
                      navData.isActive ? 'active-page' : ''
                    }
                  >
                    <Icon icon="mdi:office-building" className="text-primary-600 w-5 h-5 mr-2" />Whatsapp Settings
                  </NavLink>
                </li>

              </ul>
            </li>
          </ul>
          <ul
            className='sidebar-menu'
            style={{

            }}
          >
            {(
              <ul
                className='sidebar-menu'
                style={{
                  position: 'absolute',
                  bottom: '10px',
                  borderRadius: '16px',
                  left: 0,
                  right: 0,
                  padding: '10px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#f9f9f9',
                  margin: '10px'
                }}
              >
                <li className='d-flex align-items-center gap-2 mb-2' title='Docs & Support'>
                  <Link to='https://docs.callhq.ai/' className='d-flex align-items-center text-primary-600 text-sm fw-semibold' style={{ textDecoration: 'none' }}>
                    <Icon icon='mdi:lifebuoy' width='20' height='20' className='mr-2' />
                    <span className="ml-10">Docs & Support</span>
                  </Link>
                </li>
                <li className='d-flex align-items-center gap-2 mb-2' title='View Subscriptions'>
                  <Link to='/setting/billing' className='d-flex align-items-center text-warning-main text-sm fw-semibold' style={{ textDecoration: 'none' }}>
                    <Icon icon='mdi:credit-card-outline' width='20' height='20' className='mr-2' />
                    <span className="ml-10">Billing & Add-ons</span>
                  </Link>
                </li>
                <li className='d-flex align-items-center gap-2' title='Subscription Status'>
                  <Link
                    to='#'
                    className={`d-flex align-items-center text-sm fw-semibold ${orgIsSubscribed
                      ? 'text-success'
                      :
                      'text-danger'
                      }`}
                    style={{ textDecoration: 'none' }}
                  >
                    <Icon
                      icon={
                        orgIsSubscribed
                          ? 'mdi:check-circle-outline'

                          : 'mdi:alert-circle-outline'
                      }
                      width='20'
                      height='20'
                      className='mr-2'
                    />
                    <span className='ml-10'>
                      {orgIsSubscribed
                        ? 'Subscribed'
                        :
                        'Not Subscribed'}
                    </span>
                  </Link>
                </li>
              </ul>
            )}

          </ul>
        </div>


      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
        // margin top is used to push the content down when the banner is shown
        style={{ marginTop: showBanner ? "40px" : "0" }}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>

                {/* <form className='navbar-search'>
                  <input type='text' name='search' placeholder='Search' />
                  <Icon icon='ion:search-outline' className='icon' />
                </form> */}
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    backgroundColor: bgColor,
                    color: textColor,
                    fontWeight: 500,
                    padding: '6px 12px',
                    borderRadius: '12px',
                    fontSize: '14px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  }}
                >
                  <Wallet size={16} />
                  {displayText}
                </div>

                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'



                  >

                    {authData?.user?.displayName ? (
                      <div
                        className="w-40-px h-40-px rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold text-sm"
                        style={{ fontSize: "14px", textTransform: "uppercase", }}
                      >
                        {authData.user.displayName
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .slice(0, 2)}
                      </div>
                    ) : (
                      <img
                        src="/assets/images/avatar-placeholder.svg"
                        alt="avatar"
                        className="w-40-px h-40-px object-fit-cover rounded-circle"
                      />
                    )}
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {displayName}
                        </h6>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <X className="icon text-xl" />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/view-profile'

                        >
                          <UserCircle className="icon text-xl" />{" "}
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/sign-in'
                          onClick={() => {
                            logout();
                            dispatch(clearUser())
                          }}
                        >
                          <Power className="icon text-xl" />
                          {" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        {/* <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>©2025 CallHQ.ai. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0'>
                Powered By <span className='text-primary-600'>Broki Services Pvt Ltd</span>
              </p>
            </div>
          </div>
        </footer> */}
      </main>
    </section>
    </>
  );
};

export default MasterLayout;
